/* global require*/

import Vue from 'vue'
import Vuex from 'vuex'
import { event } from 'vue-analytics'

var moment = require('moment')
Vue.use(moment)
Vue.use(Vuex)

const state = {
    // starting payload
    payload: {
        action: 'getStarterKit',
        cruiseID: 0,
        cabins: [{ volwassenen: 2, jeugd: 0, kinderen: 0, baby: 0 }],
        sailingID: null,
        rateCode: '',
        cabinCode: null,
        cabinNumber: null,
        airTradeSession: null,
        cabinIndex: 0,

        findOutboundDepartAirport: null,
        findOutboundArriveAirport: null,
        findOutboundArriveDate: null,
        findOutboundArriveTime: null,

        findInboundDepartDate: null,
        findInboundDepartTime: null,
        findInboundDepartAirport: null,
        findInboundArriveAirport: null,

        findCarrier: null,
        availableFlightCarriers: [],

        returnAllAirports: null,
        returnAirports: null,
        seekDatabase: null,
        seekTransavia: null,
        seekAirTrade: null,
        seekAmadeus: null,
        nonStopOnly: null,
        flightClass: null,

        //total pax for flightfinder
        totalAdults: null,
        totalKids: null,
        totalInfants: null,
        fooien_requested: true,

        // selected inbound or outbound flights
        inbound: [],

        // selected inbound or outbound flights
        outbound: [],

        filteredFlights: [], //deprecated

        // total flights price
        totalPrice: null,

        // selected dossierID
        dossierID: null,
    },
    response: { error: false, track: false, messages: [] },

    waiting: false,
    availabilityReceived: false, // api availability cabin / price retrieval complete
    ajaxCalls: 0, // amount of calls needed before all cabin prices have been retrieved

    // Constants
    calamiteitenFonds: 2.5,
    sgrFonds: 2.5,
    cabinMaxPax: 5,
    cabinCount: 1,
    regionalDays: [
        { shortName: 'Mon', index: 1, regionalName: 'Maandag' },
        { shortName: 'Tue', index: 2, regionalName: 'Dinsdag' },
        { shortName: 'Wed', index: 3, regionalName: 'Woensdag' },
        { shortName: 'Thu', index: 4, regionalName: 'Donderdag' },
        { shortName: 'Fri', index: 5, regionalName: 'Vrijdag' },
        { shortName: 'Sat', index: 6, regionalName: 'Zaterdag' },
        { shortName: 'Sun', index: 0, regionalName: 'Zondag' },
    ],

    //
    // user input
    //
    highlightedRate: {
        cruiseID: 0,
        departureIndex: null,
        cabinIndex: 0,
        cabinType: 'Binnenhut',
    },

    // Cabin/Pax Configuration
    cabinSetup: [
        {
            rateSelectIndex: 0,
            volwassenen: 2,
            kindCount: 0,
            jeugd: 0,
            kinderen: 0,
            baby: 0,
            kindLeeftijden: [12, 12, 12, 12, 12],
            kindGeboortedatum: [
                '01-01-2019',
                '01-01-2019',
                '01-01-2019',
                '01-01-2019',
                '01-01-2019',
            ],
        },
        {
            rateSelectIndex: 0,
            volwassenen: 2,
            kindCount: 0,
            jeugd: 0,
            kinderen: 0,
            baby: 0,
            kindLeeftijden: [12, 12, 12, 12, 12],
            kindGeboortedatum: [
                '01-01-2019',
                '01-01-2019',
                '01-01-2019',
                '01-01-2019',
                '01-01-2019',
            ],
        },
        {
            rateSelectIndex: 0,
            volwassenen: 2,
            kindCount: 0,
            jeugd: 0,
            kinderen: 0,
            baby: 0,
            kindLeeftijden: [12, 12, 12, 12, 12],
            kindGeboortedatum: [
                '01-01-2019',
                '01-01-2019',
                '01-01-2019',
                '01-01-2019',
                '01-01-2019',
            ],
        },
        {
            rateSelectIndex: 0,
            volwassenen: 2,
            kindCount: 0,
            jeugd: 0,
            kinderen: 0,
            baby: 0,
            kindLeeftijden: [12, 12, 12, 12, 12],
            kindGeboortedatum: [
                '01-01-2019',
                '01-01-2019',
                '01-01-2019',
                '01-01-2019',
                '01-01-2019',
            ],
        },
        {
            rateSelectIndex: 0,
            volwassenen: 2,
            kindCount: 0,
            jeugd: 0,
            kinderen: 0,
            baby: 0,
            kindLeeftijden: [12, 12, 12, 12, 12],
            kindGeboortedatum: [
                '01-01-2019',
                '01-01-2019',
                '01-01-2019',
                '01-01-2019',
                '01-01-2019',
            ],
        },
    ],

    // volpension/all-inclusive
    verzorgingType: 'volpension',

    // inclusief/exclusief
    fooienType: 'exclusief',

    selectedPakket: null,

    // selected flight group
    selectedFlight: null,

    //Flight settings
    findFlights: true,
    findInboundOnly: false,
    findOutboundOnly: false,

    // show hide mobile menu
    showMobileMenu: false,

    selectedCabinIndex: 0,
    //
    // header
    //
    subscriberCount: 26459, // default subscriber count before update from api

    // cruise itinerary and ship information
    cruise: {
        id: null,
        found: false, // if found in db set to true
        schip_id: null,
        rederij_id: null,
        vaarroute: null,
        begindatum: null,
        terugkeerdatum: null,
        vaarroute_detail: null,
        bestemming_naam: null,
        schip_naam: null,
        schip_all_inclusive: null,
        duur: null,
        embarktime: null,
        dissembarktime: null,
        verzorging: null,
        cruise_code: null,
        schip_code: null,
        itinerary: {
            days: [
                {
                    code: null,
                    id: null,
                    haven_naam: null,
                    date: null,
                    date_nl: null,
                    departure: null,
                    highlight1: null,
                    highlight2: null,
                    land_naam: null,
                    lat: null,
                    lng: null,
                    transPriceMin: null,
                    transPricePP: null,
                },
            ],
        },
        titel: null,
        begindatum_nl: null,
        ist_itin_code: null,
        thema_id: 0,
        discount_level: null,
        terugkeerdatum_nl: null,
        isLocalDeparture: null,
        searchFlights: null,
        ratecode_usps: {},
        rederij_naam: null,
        cruise_omschrijving: null,
        imgs: [],
        detailed: false,
        rederij_video_id: null,
        rederij_thumbnail_url: 'https://cdn.cruisereizen.nl/img/rederijen/placeholders/placeholder_overig_500.jpg',
        rederij_usps: [],
        schip_usps: [],
        titel_havens: null,
        cruise_id: null, //dub
        code: null, //dub
        fibos_boeken: null,
        fibos_regions: null,
        dinerzitting_default: null,
        inbegrepen: null,
        niet_inbegrepen: null,
        logo_url: null,
        rederij_alias: null,
        schip_img: null,
        rederij_img_string: null,
        vaarroute_img: null,
        rederij_omschrijving: null,
        schip_omschrijving: null,
        rederij_omschrijving_kort: null,
        schip_omschrijving_kort: null,
        rederij_omschrijving_landing: null,
        schip_ncl_code: null,

        outbound_transferprijs: null, // deprecated
        outbound_min_transferprijs: null, //deprecated
        inbound_transferprijs: null,
        inbound_min_transferprijs: null,

        content_drankenpakketten: null,
        tarief_drankenpakket_volwassenen: null,
        tarief_drankenpakket_kinderen: null,

        content_fooien: null,
        fooien_type: 'exclusief',
        tarief_fooien_volwassenen: {
            globaal: 0,
            binnenhut: 0,
            buitenhut: 0,
            suite: 0,
        },
        tarief_fooien_kinderen: {
            globaal: 0,
            binnenhut: 0,
            buitenhut: 0,
            suite: 0,
        },
        tarief_fooien_baby: {
            globaal: 0,
            binnenhut: 0,
            buitenhut: 0,
            suite: 0,
        },
    },

    // all rates for similar itineraries
    // departures as list[departure date] = collectionIndex)
    // and collection containing (departure index->cabin type->cabin category + rate + price) structure
    departures: {
        collection: [
            {
                0: {
                    Balkonhut: [
                        {
                            rateID: 0,
                            prijs: 0,
                            brochure: 0,
                            cabinCode: null,
                            rateCode: null,
                        },
                    ],
                },
            },
        ],
        list: [],
        // eg list:  [0:'2019-01-01',1:'2019-01-14'],
    },

    // refreshes through ajax on departure index change, uses caching
    campagnes: [],

    // refreshes through ajax on departure index change, uses caching
    flights: [],

    airports: [{ name: 'Bezig met laden...', iata_code: null }],

    availableFlightCarriers: [{ name: 'Bezig met laden...', code: '' }],
    availableRatesFlights: [{ name: 'Bezig met laden...', code: '' }],

    departOptions: [],

    // contains cabins collection with category information like window/paxcount
    cabins: [],
    // contains available cabinNumbers for selected category
    cabinNumbers: null,
    fooien: null,
    dossierInfo: null,

    // contains available names after cabin availability call
    availableRates: [],

    // contains retrieved api results for cruise.
    apiData: [],

    //
    // starterpack
    //

    // example cabins and cabin types available for ship.
    cabinTypes: {
        collection: [
            {
                value: 0,
                selected: false,
                text: null,
                sample: {
                    apiData: false,
                    typeExample: false,
                    id: null,
                    code: null,
                    type: null,
                    naam: null,
                    omschrijving: null,
                    img_url: null,
                    min_bezetting: 0,
                    max_bezetting: 0,
                    img_plattegrond_url: null,
                },
            },
        ],
    },
    //Keep count of displayed cabins
    cabinCounter: 0,

    cabinChanged: 0,

    // passenger types/jeugd/volwassen
    paxTypes: {
        collection: ['volwassenen', 'jeugd', 'kinderen', 'baby'],
    },

    // array contain specialist name + image for random include
    cruiseSpecialists: null,

    // returned offer status
    offerStatus: {
        dossiernummer: null,
        status: null,
        loading: false,
    },

    // returned bel me config api call
    belMeConfig: null,
    belMeData: {
        message: null,
        success: false,
    },

    //
    // api call not implemented yet
    //
    deckMap: null,
    deckNames: null,
    deckImages: null,
    showDeckMap: false,
    paxInfo: null,
    nationalities: null,

    //    Array of local harbors
    localHarbours: ['1', '104', '22661', '255'],

    //    Status of flight call
    flightLoading: false,

    isKantoorIP: null,
}

const mutations = {
    // delete given harbor routes
    deleteRoutes(state, input) {
        state.payload.action = 'deleteRoutes'
        state.payload.routes = input.routes
        $.ajax({
            url: '/paginas/boeken2/ajax.php',
            method: 'GET',
            data: state.payload,
            success: function(responseData) {
                console.log(responseData)
            }
        })
    },

    //
    // Highlighting selections
    //

    // change departure index/date
    mutateDeparture(state, input) {
        if (state.highlightedRate.cruiseID !== parseInt(input.cruiseID)) {
            state.selectedFlight = 'NO'
        }
        state.highlightedRate.cruiseID = input.cruiseID
        state.highlightedRate.departureIndex = input.departureIndex
    },

    // Function matches all store rates to given rateID or rateCode
    // and saves the index of that rate to the store Cabinsetup
    mutateDepartureRate(state, { input, getters }) {
        // Barebone supplement for func to run (without url update):
        // updatePriceOnly,
        // rateID or rateCode(name of rate),
        // flatRate
        let currentRate
        let self = this
        let urlData = {}

        let flatRates = getters.flattenedRates

        flatRates.map((rate, index) => {
            //If ratecode is recieved instead of RateID
            // (Ratecode is the string, RateID is the ID of the rate)
            if (input.rateCode) {
                // Strip % from both values,
                // because ratecode in the url is without %
                const rateCode = rate.rateCode.replace('%', '')
                const inputCode = input.rateCode.replace('%', '')
                if (
                    rateCode === inputCode &&
                    rate.cabinCode === input.cabinCode
                ) {
                    currentRate = index
                    urlData = {
                        input,
                        rate,
                    }
                }
            } else if (rate.rateID === input.rateID) {
                currentRate = index
                urlData = {
                    input,
                    rate,
                }
            }
        })
        // Change url with new data
        if (
            !input.updatePriceOnly &&
            urlData &&
            urlData.input &&
            urlData.input.route
        ) {
            self.commit('mutateUrl', urlData)
        }

        //Set each cabin to the selected rate
        //Current rate is the index of the loaded rates
        //rateSelect index holds a selected index of a rate
        for (let i = 0; i <= state.cabinCount - 1; i++) {
            state.cabinSetup[i].rateSelectIndex = currentRate
        }
    },

    //Alter URL - insert data into it
    mutateUrl(state, data) {
        //Build new url dataset
        const urlString = data.input.route.fullPath
        const dataRoute = data.input.route
        const dataRate = data.rate
        const urlData = {
            link: urlString,
            data: [
                {
                    current: dataRoute.params.rate,
                    new: dataRate.rateCode.replace('%', ''),
                },
                {
                    current: dataRoute.params.hutType,
                    new: dataRate.type,
                },
                {
                    current: dataRoute.params.hutCat,
                    new: dataRate.cabinCode,
                },
                {
                    current: dataRoute.params.departureDate,
                    new: data.input.date,
                },
                {
                    current: dataRoute.params.id,
                    new: data.input.cruiseID,
                },
            ],
        }

        let newUrl = urlData.link
        urlData.data.map(data => {
            if (data.new) {
                if (data.current) {
                    newUrl = newUrl.replace(data.current, data.new)
                } else {
                    newUrl = newUrl + '/' + data.new
                }
            }
        })
        window.history.pushState('overzicht', 'Cruise', newUrl)
    },

    // change active cabinindex
    changeCabinRate(state, input) {
        state.cabinChanged = true
        state.cabinSetup[input.cabinSetupIndex].rateSelectIndex =
            input.rateSelectIndex

        //wip
        // if(input.rateCode){
        //     let urlString =  input.route.fullPath
        //     const urlData = {
        //         link: urlString,
        //         data: [
        //             {
        //                 current: dataRoute.params.id,
        //                 new: data.input.cruiseID,
        //             },
        //         ],
        //     }
        //
        //     let newUrl = urlData.link
        //     urlData.data.map(data => {
        //         if (data.new) {
        //             if (data.current) {
        //                 newUrl = newUrl.replace(data.current, data.new)
        //             } else {
        //                 newUrl = newUrl + '/' + data.new
        //             }
        //         }
        //     })
        // }

    //    set url
    },

    // change cabin pax composition
    changeCabinSetup(state, input) {
        let index = input.cabinSetupIndex

        if (input.volwCount != undefined) {
            state.cabinSetup[index].volwassenen = parseInt(input.volwCount)
        }

        if (input.kindCount != undefined) {
            state.cabinSetup[index].kindCount = parseInt(input.kindCount)
        }

        if (input.childIndex != undefined && input.childAge != undefined) {
            state.cabinSetup[index].kindLeeftijden[
                input.childIndex - 1
            ] = parseInt(input.childAge)
        }
        if (input.childIndex != undefined && input.childBirthday != undefined) {
            state.cabinSetup[index].kindGeboortedatum[input.childIndex - 1] =
                input.childBirthday
        }

        state.cabinSetup[index].baby = 0
        state.cabinSetup[index].kinderen = 0
        state.cabinSetup[index].jeugd = 0

        for (let i = 0; i <= state.cabinSetup[index].kindCount - 1; i++) {
            state.cabinSetup[index].kinderen += 1
        }
    },

    //
    // Mutate global state with API data
    //

    // load cruise departures and rates for owner/ship/itinerary
    mutateCruise(state, { input, getters }) {
        let self = this
        let cruiseID = input.cruiseID
        if (parseInt(cruiseID) <= 0) {
            this.commit('logError', {
                error: true,
                track: true,
                messages: ['Mutate Cruise, invalid input'],
            })
            return
        }
        if (state.cruise.cruise_id !== cruiseID) {
            // not last loaded
            state.payload.action = 'getCruise'
            state.selectedCabinIndex = 0
            state.payload.cruiseID = cruiseID

            $.ajax({
                url: '/paginas/boeken2/ajax.php',
                method: 'GET',
                data: state.payload,
                success: function(responseData) {
                    state.payload = responseData.payload
                    state.cruise = responseData.cruise
                    state.cabinTypes = responseData.cabinTypes
                    state.cabins = responseData.cabins
                    state.dossierInfo = responseData.dossierInfo
                    state.fooien = responseData.fooien
                    //state.cabinNumbers = responseData.cabinNumbers;

                    state.cruiseSpecialists = responseData.cruiseSpecialists
                    state.belMeConfig = responseData.belMeConfig
                    state.deckNames = responseData.deckNames
                    state.deckImages = responseData.deckImages
                    state.subscriberCount = responseData.subscriberCount
                    state.isKantoorIP = responseData.ipAccess

                    if (responseData.discount) {
                        state.discount = responseData.discount
                    }
                    self.commit('logError', responseData.response)
                    self.commit('mutateRates', { input, getters })
                    self.commit('mutateCruiseVideo')
                },
                error: function(error) {
                    self.commit('logError', error)
                },
            })
        }
    },
    // load rates for all departures containing the same sequence of ports
    // in itinerary, vessel and owner.
    mutateRates(state, { input, getters }) {
        const self = this
        const cruiseID = input.cruiseID
        const departureDate = input.departureDate

        state.selectedCabinIndex = input.cabinIndex
        state.payload.action = 'getCruiseRates'
        state.cruiseID = cruiseID

        let urlID = input.route.params.id
        if (typeof urlID != 'number') {
            urlID = parseInt(urlID.split('-').pop())
        }

        $.ajax({
            url: '/paginas/boeken2/ajax.php',
            method: 'GET',
            data: state.payload,
            success: function(responseData) {
                state.payload = responseData.payload
                state.departures = responseData.departures
                responseData.departures.list.map(departure => {
                    if (departure.cruiseID === urlID) {
                        state.highlightedRate.cruiseID = parseInt(
                            departure.cruiseID
                        )
                    }
                })
                let data = {
                    departureDate: departureDate,
                    route: input.route,
                }
                self.commit('logError', responseData.response)
                self.commit('mutateToDefaultRate', { data, getters })
            },
            error: function(error) {
                self.commit('logError', error)
            },
        })
    },

    // find lowest rate or departuredate when mutateRates saved and retrieved
    mutateToDefaultRate(state, { data, getters }) {
        let self = this
        let departure = null
        let departureIndex = null
        let lowestRate
        let departureDate = data.departureDate

        // check if we need to highlight a departure date first
        if (
            departureDate !== null &&
            departureDate !== '' &&
            typeof departureDate !== 'undefined'
        ) {
            departure = state.departures.list.find(function(
                departure,
                depIndex
            ) {
                let matched = departure.departureDate === departureDate
                if (matched) {
                    departureIndex = depIndex
                    return matched
                }
            })
        }

        // if we found a departure in the list
        if (departureIndex || departureIndex === 0) {
            state.highlightedRate.cruiseID = departure.cruiseID
            state.highlightedRate.departureIndex = departureIndex

            let depRates =
                state.departures.collection[state.highlightedRate.cruiseID]
            let cabinTypes = state.cabinTypes.collection
            let comArray = []

            // mix binnenhut buitenhut for sort
            cabinTypes.forEach(function(cabinType) {
                let cabinTypeRates = depRates[cabinType.text]
                if (typeof cabinTypeRates === 'undefined') {
                    return
                }

                cabinTypeRates.forEach(function(rate) {
                    comArray.push({ type: cabinType.text, rate: rate })
                })
            })

            // find lowest price for departure
            let sortedCom = comArray.sort(function(a, b) {
                return a.rate.prijs > b.rate.prijs
            })
            lowestRate = sortedCom[0]
        } else {
            // no departure highlighted check all prices for lowest value
            let departures = state.departures.collection
            let cabinTypes = state.cabinTypes.collection
            let comArray = []

            // loop through our departures
            Object.keys(departures).forEach(function(cruiseID, depIndex) {
                let depRates = departures[cruiseID]

                // loop though cabintypes and flatten rates using comArray
                cabinTypes.forEach(function(cabinType) {
                    let cabinRates = depRates[cabinType.text]
                    if (typeof cabinRates === 'undefined') {
                        // cabintype has no rates
                        return
                    }
                    // loop through cabintype rates and flatten into comArray
                    cabinRates.forEach(function(rate) {
                        comArray.push({
                            cruiseID: cruiseID,
                            depIndex: depIndex,
                            type: cabinType.text,
                            rate: rate,
                        })
                    })
                })
            })

            // find lowest price for all departures in comArray
            let sortedCom = comArray.sort(function(a, b) {
                return a.rate.prijs > b.rate.prijs
            })
            lowestRate = sortedCom[0]

            state.highlightedRate.cruiseID = lowestRate.cruiseID
            state.highlightedRate.departureIndex = lowestRate.depIndex
        }

        state.highlightedRate.cabinIndex = state.selectedCabinIndex
        self.commit('mutateCampagnes', {
            cruiseID: state.highlightedRate.cruiseID,
        })
        self.commit('mutateFlights', {
            cruiseID: state.highlightedRate.cruiseID,
        })
        self.commit('updateCriteoWithCruise', {
            begindatum: state.cruise.begindatum,
            terugkeerdatum: state.cruise.terugkeerdatum,
            cruiseID: state.highlightedRate.cruiseID,
        })

        const route = data.route
        const params = data.route.params
        if (route && params) {
            const cruiseID = params.id
            const cabinTypeName = params.hutType
            const date = params.departureDate
            const rateCode = params.rate
            const cabinCode = params.hutCat
            let cabinTypeIndex
            if (cabinTypeName === 'Binnenhut') {
                cabinTypeIndex = 0
            } else if (cabinTypeName === 'Buitenhut') {
                cabinTypeIndex = 1
            } else if (cabinTypeName === 'Balkonhut') {
                cabinTypeIndex = 2
            } else if (cabinTypeName === 'Suite') {
                cabinTypeIndex = 3
            }
            const flatRates = getters.flattenedRates

            if (cruiseID && cabinTypeName && rateCode && cabinTypeIndex) {
                //Save url stuff to store
                self.dispatch('highlightDeparture', {
                    cruiseID,
                    departureIndex: 0,
                    cabinIndex: cabinTypeIndex,
                    rateCode,
                    cabinCode,
                    route,
                    date,
                    updatePriceOnly: true,
                    flatRates,
                })
            }
        }
    },

    // Update ecommerce view
    updateCriteoWithCruise: function(cruise, input) {
        const begindatum = input.begindatum
        const terugkeerdatum = input.terugkeerdatum
        const highlightedID = input.highlightedID
        // Commit to criteo
        window.criteo_q = window.criteo_q || []
        let deviceType = /iPad/.test(navigator.userAgent)
            ? 't'
            : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
                  navigator.userAgent
              )
            ? 'm'
            : 'd'
        window.criteo_q.push(
            { event: 'setAccount', account: 27414 }, // You should never update this line
            { event: 'setEmail', email: '##Email Address of user##' },
            { event: 'setSiteType', type: deviceType },
            {
                event: 'viewSearch',
                checkin_date: begindatum,
                checkout_date: terugkeerdatum,
                nbra: 2,
                nbrc: 0,
                nbri: 0,
            },
            {
                event: 'viewItem',
                item: 'Cruise_' + highlightedID,
            }
        )
    },

    //
    // Mutate specific departure/cruiseid and cache results
    //

    // load campagnes for highlighted cruiseid
    mutateCampagnes(state, input) {
        let cruiseID = input.cruiseID
        let self = this
        state.payload.action = 'getCampagnes'
        state.payload.cruiseID = cruiseID
        let current = state.campagnes.find(function(departure) {
            return departure.cruiseID === cruiseID
        })

        if (typeof current !== 'undefined') {
            // previously loaded
            return
        }

        $.ajax({
            url: '/paginas/boeken2/ajax.php',
            method: 'GET',
            data: state.payload,
            success: function(responseData) {
                state.campagnes.push({
                    cruiseID: cruiseID,
                    campagnes: responseData.campagnes,
                })
                self.commit('logError', responseData.response)
            },
            error: function(error) {
                self.commit('logError', error)
            },
        })
    },

    // loadflights for highlighted cruiseid
    mutateFlights(state, input) {
        let cruiseID = input.cruiseID
        let self = this

        state.payload.action = 'getCruiseFlights'
        state.payload.seekDatabase = true
        state.payload.cruiseID = cruiseID

        let route = state.cruise.vaarroute.split(',')
        const localHarbours = state.localHarbours

        if (
            localHarbours.includes(route[0]) &&
            localHarbours.includes(route[route.length - 1])
        ) {
            state.findFlights = false
            return
        } else if (localHarbours.includes(route[0])) {
            state.findInboundOnly = true
        } else if (localHarbours.includes(route[route.length - 1])) {
            state.findOutboundOnly = true
        }

        for (let i = 0; i <= state.cabinCount - 1; i++) {
            state.payload.cabins[i] = state.cabinSetup[i]
        }

        let current = state.flights.find(function(flight) {
            return flight.cruiseID === cruiseID
        })

        if (typeof current !== 'undefined') {
            // loaded before
            return
        }
        state.flightLoading = true
        $.ajax({
            url: '/paginas/boeken2/ajax.php',
            method: 'GET',
            data: state.payload,
            success: function(responseData) {
                state.payload = responseData.payload
                state.flightLoading = false
                state.flights.push({
                    cruiseID: cruiseID,
                    results: responseData.flights,
                })
                self.commit('logError', responseData.response)
            },
            error: function(error) {
                self.commit('logError', error)
            },
        })
    },

    //
    // For flightfinder.vue and cabinfinder.vue views
    //

    // load flights based on payload dossierid
    mutateFlightsForDossier(state, input) {
        let self = this
        let dossierID = input.dossierID

        state.payload.action = 'getCruiseFlightsForDossier'
        state.payload.dossierID = dossierID

        state.payload.findOutboundDepartAirport =
            input.findOutboundDepartAirport
        state.payload.findOutboundArriveDate = input.findOutboundArriveDate
        state.payload.findOutboundArriveAirport =
            input.findOutboundArriveAirport
        state.payload.findInboundDepartDate = input.findInboundDepartDate
        state.payload.findInboundDepartAirport = input.findInboundDepartAirport
        state.payload.findInboundArriveAirport = input.findInboundArriveAirport

        state.payload.findEmbarkTime = input.findEmbarkTime
        state.payload.findDisembarkTime = input.findDisembarkTime

        state.payload.returnAllAirports = input.returnAllAirports
        state.payload.returnAirports = input.returnAirports
        state.payload.seekDatabase = input.seekDatabase
        state.payload.seekAirTrade = input.seekAirTrade
        state.payload.seekAmadeus = input.seekAmadeus
        state.payload.nonStopOnly = input.nonStopOnly
        state.payload.flightClass = input.flightClass
        state.payload.totalAdults = input.totalAdults
        state.payload.totalKids = input.totalKids
        state.payload.totalInfants = input.totalInfants



        state.waiting = true

        $.ajax({
            url: '/paginas/boeken2/ajax.php',
            method: 'GET',
            data: state.payload,
            success: function(responseData) {
                state.payload = responseData.payload
                state.response = responseData.response
                state.cruise = responseData.cruise

                state.flights = responseData.flights
                state.filterSpec = responseData.filterSpec

                state.airports = responseData.airports
                state.availableFlightCarriers = responseData.availableFlightCarriers
                state.availableRatesFlights = responseData.availableRates
                state.departOptions = responseData.departOptions

                state.waiting = false
                self.commit('logError', responseData.response)
            },
            error: function(error) {
                self.commit('logError', error)
                state.waiting = false
            },
        })
    },


    mutateAirportsForDossier(state, input) {
        let self = this
        let dossierID = input.dossierID

        state.payload.action = 'getAirportsForDossier'
        state.payload.dossierID = dossierID

        state.payload.findOutboundDepartAirport =
            input.findOutboundDepartAirport
        state.payload.findOutboundArriveDate = input.findOutboundArriveDate
        state.payload.findOutboundArriveAirport =
            input.findOutboundArriveAirport
        state.payload.findInboundDepartDate = input.findInboundDepartDate
        state.payload.findInboundDepartAirport = input.findInboundDepartAirport
        state.payload.findInboundArriveAirport = input.findInboundArriveAirport

        state.payload.findEmbarkTime = input.findEmbarkTime
        state.payload.findDisembarkTime = input.findDisembarkTime

        state.payload.returnAllAirports = input.returnAllAirports
        state.payload.returnAirports = input.returnAirports
        state.payload.seekDatabase = input.seekDatabase
        state.payload.seekAirTrade = input.seekAirTrade
        state.payload.seekAmadeus = input.seekAmadeus
        state.payload.nonStopOnly = input.nonStopOnly
        state.payload.flightClass = input.flightClass
        state.payload.totalAdults = input.totalAdults
        state.payload.totalKids = input.totalKids
        state.payload.totalInfants = input.totalInfants



        state.waiting = true

        $.ajax({
            url: '/paginas/boeken2/ajax.php',
            method: 'GET',
            data: state.payload,
            success: function(responseData) {
                state.payload = responseData.payload
                state.response = responseData.response
                state.cruise = responseData.cruise

                state.flights = responseData.flights
                state.filterSpec = responseData.filterSpec

                state.airports = responseData.airports
                state.availableFlightCarriers =
                    responseData.availableFlightCarriers
                state.departOptions = responseData.departOptions

                state.waiting = false
                self.commit('logError', responseData.response)
            },
            error: function(error) {
                self.commit('logError', error)
                state.waiting = false
            },
        })
    },

    // Add selected flights to existing dossierid
    mutateAddFlightToDossier(state, flights) {
        state.payload.inbound = flights.inbound
        state.payload.outbound = flights.outbound
        state.payload.totalPrice = flights.totalPrice
        state.payload.fareOption = flights.fareOption ? flights.fareOption : []
        state.payload.action = 'addFlightsToDossier'

        $.ajax({
            url: '/paginas/boeken2/ajax.php',
            method: 'POST',
            data: state.payload,
            success: function(responseData) {
                state.response = responseData.response
                self.commit('logError', responseData.response)
            },
            error: function(error) {
                self.commit('logError', error)
            },
        })
    },

    // load cabins from apirederijconnection cabinavailability
    // on payload dossierid and cabinindex
    mutateCabinsForDossier(state, input) {
        let dossierID = input.dossierID
        let cabinIndex = input.cabinIndex
        let rateCode = input.rateCode
        let self = this

        state.payload.action = 'getCruiseCabinsForDossier'
        state.payload.dossierID = dossierID
        state.payload.cabinIndex = cabinIndex
        state.payload.rateCode = rateCode
        state.waiting = true

        state.cabins = []
        state.availabilityReceived = false
        $.ajax({
            url: '/paginas/boeken2/ajax.php',
            method: 'GET',
            data: state.payload,
            success: function(responseData) {
                state.cruise = responseData.cruise
                state.payload = responseData.payload
                state.response = responseData.response
                state.availableRates = responseData.availableRates
                state.cabins = responseData.cabins
                state.cabinTypes = responseData.cabinTypes
                state.apiData = responseData.apiData

                state.waiting = false
                self.commit('logError', responseData.response)
                self.commit('mutateCabinCollectionWithAPIData')
            },
            error: function(error) {
                self.commit('logError', error)
            },
        })
    },

    // mix cabin collection with api data and api
    // call price update for every cabin category
    // after mutateCabinsForDossier recieved and saved
    mutateCabinCollectionWithAPIData(state) {
        let missingCodes = []
        let self = this

        if (Array.isArray(state.apiData)) {
            state.apiData.forEach(function(data) {
                let found = false
                // loop through cabin collection
                state.cabins.collection.forEach(function(cabin) {
                    // find matching results
                    if (cabin.code === data.code) {
                        // inject apiData into matching cabin
                        if (cabin.apiData === false) {
                            cabin.apiData = []
                        }
                        cabin.apiData.push(data)
                        found = true
                    }
                })
                if (!found) {
                    missingCodes.push(data.code)
                }
            })

            if (missingCodes.length > 0) {
                this.dispatch('saveLog', {
                    error: false,
                    track: true,
                    messages: [
                        'Cabin(s) not found in database but available in api: ' +
                            missingCodes.join(', '),
                    ],
                })
            }
        }
        // loop through cabin collection and if retrieve price needed  do async ajax calls
        state.cabins.collection.forEach(function(cabin) {
            if (cabin.apiData) {
                cabin.apiData.forEach(function(element) {
                    if (element.retrievePrice) {
                        state.ajaxCalls++
                        state.payload.action = 'getCabinPrice'
                        state.payload.cabinCode = cabin.code
                        state.payload.sailingID = element.sailingID
                        state.payload.rateCode = element.rateCode
                        $.ajax({
                            url: '/paginas/boeken2/ajax.php',
                            method: 'GET',
                            data: state.payload,
                            success: function(responseData) {
                                self.commit('logError', responseData.response)
                                state.ajaxCalls--
                                if (!state.error) {
                                    //state.logResponse({error: false, track: true, messages: ['Got price']});
                                    // loop through collection to find cabin and set price
                                    state.cabins.collection.some(function(
                                        cabin
                                    ) {
                                        // find matching results
                                        if (
                                            responseData.apiData[0] &&
                                            cabin.code ===
                                                responseData.apiData[0].code &&
                                            cabin.apiData
                                        ) {
                                            // block updates
                                            if (cabin.apiData.retrievePrice) {
                                                cabin.apiData.retrievePrice = false
                                            }
                                            // update price

                                            cabin.apiData[0].prijs =
                                                responseData.apiData[0].prijs
                                            cabin.apiData[0].priceBreakDown =
                                                responseData.apiData[0].priceBreakDown
                                            // break loop
                                            return true
                                        }
                                    })

                                    if (state.ajaxCalls === 0) {
                                        state.availabilityReceived = true
                                    }
                                }
                            },
                            error: function(error) {
                                self.commit('logError', error)
                                state.ajaxCalls--
                                state.response.error = true
                                state.response.messages.push(error)
                            },
                        })
                    }
                })
            }
        })
        if (state.ajaxCalls === 0) {
            state.availabilityReceived = true
        }
    },

    // Retrieve available cabins for selected cabin
    mutateCabinNumbers(state, input) {
        let self = this
        let apidata = input.apiData
        //let cabin = input.cabin

        if (!state.availabilityReceived) return false

        state.cabinNumbers = {}
        state.deckMap = null
        state.cabinNumbersReceived = false
        state.deckMapReceived = false

        state.payload.action = 'getCabinNumbers'
        state.payload.cabinCode = apidata.code
        state.payload.rateCode = apidata.rateCode
        state.payload.planCode = apidata.planCode
        state.payload.componentID = apidata.componentID
        state.payload.packageCode = apidata.packageCode
        state.payload.packageItemCode = apidata.packageItemCode
        state.payload.sailingID = apidata.sailingID
        state.payload.sessionID = apidata.sessionID

        $.ajax({
            url: '/paginas/boeken2/ajax.php',
            method: 'GET',
            data: state.payload,
            success: function(responseData) {
                self.commit('logError', responseData.response)
                state.waiting = false
                if (!state.error) {
                    state.cabinNumbers = responseData.cabinNumbers
                    state.cabinNumbersReceived = true


                }
            },
            error: function(error) {
                self.commit('logError', error)
                state.waiting = false
                state.cabinNumbers = []
                state.cabinNumbersReceived = false
            },
        })
    },

    mutateToggleFooi(state, input) {
        console.warn(input.fooi)
        state.payload.fooien_requested = input.fooi
    },

    // retrieve deckmap
    mutateDeckMap(state) {
        let self = this
        let cabinNumber = state.cabinNumbers.selected

        state.deckMapReceived = false
        state.deckMap = null

        state.payload.action = 'getDeckMap'
        state.payload.cabinNumber = cabinNumber
        $.ajax({
            url: '/paginas/boeken2/ajax.php',
            method: 'GET',
            data: state.payload,
            success: function(responseData) {
                self.commit('logError', responseData.response)
                state.waiting = false
                if (!self.error) {
                    if (responseData.deckMap.html !== '') {
                        state.deckMap = responseData.deckMap
                        state.deckMapReceived = true
                    }
                }
            },
            error: function(error) {
                self.commit('logError', error)
                state.waiting = false
                state.deckMapReceived = false
                state.deckMap = null
            },
        })
    },

    // Add selected flights to existing dossierid
    mutateAddCabinToDossier(state, input) {
        let self = this
        let cabinIndex = input.cabinIndex
        let cabin = input.apiData
        let cabinType = input.cabinType
        let cabinNumber = state.cabinNumbers.selected

        // add our cabin settings to our state payload
        Object.keys(cabin).forEach(function(el) {
            state.payload.cabins[cabinIndex][el] = cabin[el]
        })

        state.payload.cabins[cabinIndex]['cabinType'] = cabinType
        state.payload.cabins[cabinIndex]['hutnummer'] = cabinNumber

        state.payload.action = 'addCabinToDossier'

        $.ajax({
            url: '/paginas/boeken2/ajax.php',
            method: 'GET',
            data: state.payload,
            success: function(responseData) {
                self.commit('logError', responseData.response)
                state.response = responseData.response
            },
            error: function(error) {
                self.commit('logError', error)
            },
        })
    },

    //
    // Send service requests for user cruisepagina/overzicht
    //
    // save offer/quote request
    mutateSaveOfferRequest(state, payload) {
        state.offerStatus.loading = true
        let self = this
        $.ajax({
            url: '/paginas/boeken2/ajax.php',
            method: 'GET',
            data: payload,
            success: function(responseData) {
                self.commit('logError', responseData.response)
                //@todo move to own function
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    ecommerce: {
                        purchase: {
                            actionField: {
                                id: responseData.dossiernummer,
                                affiliation: 'Online Store',
                                revenue: payload.totalPrice,
                                tax: '0',
                            },
                            products: [
                                {
                                    name: state.cruise.titel,
                                    id: state.cruise.id,
                                    price: payload.totalPrice,
                                    brand: state.cruise.rederij_naam,
                                    category: state.cruise.begindatum,
                                    variant: state.cruise.begindatum,
                                    quantity: 1,
                                    vessel: state.cruise.schip_naam,
                                    destination: state.cruise.bestemming_naam,
                                },
                            ],
                        },
                    },
                    event: 'transactionComplete',
                })
                state.offerStatus.dossiernummer = responseData.dossiernummer
                state.offerStatus.status = responseData.offerState
                state.offerStatus.loading = false
            },
            error: function(error) {
                self.commit('logError', error)
            },
        })
    },

    // send bel me terug/callback request
    // calls back spearate api
    mutateBelMeRequest(state, input) {
        let self = this
        let payload = {}
        payload.postback = true
        payload.belme_naam = input.name
        payload.belme_nummer = input.number
        payload.belme_uri = window.location.href
        $.ajax({
            url: '/belme',
            method: 'POST',
            data: payload,
            success: function(responseData) {
                self.commit('logError', responseData.response)
                state.belMeData.success = responseData.success
                state.belMeData.message = responseData.message
            },
            error: function(error) {
                self.commit('logError', error)
            },
        })
    },

    mutateCruiseVideo(state) {
        let self = this
        if(state.cruise.rederij_video_id) {
            let video = state.cruise.rederij_video_id
            $.ajax({
                url: 'http://fast.wistia.net/oembed?url=http://fast.wistia.com/embed/medias/' + video,
                method: 'GET',
                success: function(responseData) {
                    state.cruise.rederij_thumbnail_url = responseData.thumbnail_url
                },
                error: function(error) {
                    self.commit('logError', error)
                },
            })
        }

    },
    logError: function(state, input) {
        let msg
        if (typeof input !== 'string') {
            msg = JSON.stringify(input)
        }
        if (input.error) {
            state.response.error = true
        }
        state.response.messages.push(msg)
        if (input.track) {
            this.commit('sendEvent', input)
        }
    },
    sendEvent: function(state, response) {
        let msgPrefix = window.location.href + ' '

        if (response.error) {
            msgPrefix += 'ERROR'
        } else {
            msgPrefix += 'INFO'
        }
        let messages = response.messages.join(', ')

        if (response.error) {
            console.log('Oeps, er is iets mis gegaan: ' + messages)
        } else {
            console.log('Verbose logging is active: ' + messages)
        }

        if (response.track) {
            event(msgPrefix, messages)
        }
    },
}

const getters = {
    // Returns Specific colleciton of images from cruise for use in header
    headerImagesCruise: state => {
        let imgTypeIndex = null
        let ret = {}

        const imgTypes = [
            { name: 'ship', cdnPath: '/schepen/' },
            { name: 'port', cdnPath: '/havens/' },
            { name: 'cabin', cdnPath: '/hutten/' },
            { name: 'overig', cdnPath: '/overig/' },
        ]
        if (state.cruise && state.cruise.imgs && state.cruise.imgs.length > 0) {
            let images = state.cruise.imgs
            // normal images
            for (imgTypeIndex in imgTypes) {
                let imgType = imgTypes[imgTypeIndex]

                ret[imgType.name + 'Img'] = images.find(function(img) {
                    return img.url.indexOf('splash_' + imgType.name + '_') > 0
                })
            }

            // splash override
            for (imgTypeIndex in imgTypes) {
                let imgType = imgTypes[imgTypeIndex]

                ret[imgType.name + 'Img'] = images.find(function(img) {
                    return img.url.indexOf(imgType.cdnPath) > 0
                })
            }
        }
        return ret
    },
    // make our times numeric, removing : for numeric comparison
    currentlyOpen: state => {
        let date = new Date()
        let day = date.getDay()

        if (state.belMeConfig) {
            let result = state.regionalDays.find(function(item) {
                return item.index === day
            })
            let currentTimeInt = date.getHours() + '' + date.getMinutes()
            let currentEndTimeInt = state.belMeConfig[
                result.shortName
            ][1].replace(':', '')
            return currentTimeInt <= currentEndTimeInt
        }

        return false
    },

    // translates to more verbose collection for easier price lookup
    flattenedRates: state => {
        let retArr = []
        let cabinTypes = []
        let cruiseID = state.highlightedRate.cruiseID

        if (cruiseID <= 0) {
            return retArr
        }

        cabinTypes = state.departures.collection[cruiseID]

        if (!cabinTypes) {
            return retArr
        }

        Object.keys(cabinTypes).forEach(function(cabinTypeText) {
            let rates = cabinTypes[cabinTypeText]

            rates.forEach(function(rate) {
                retArr.push({
                    type: cabinTypeText,
                    rateID: rate.rateID,
                    cabinCode: rate.cabinCode,
                    rateCode: rate.rateCode,
                    prijs: rate.prijs,
                    brochure: rate.brochure,
                })
            })
        })

        let sortedRates = retArr.sort(function(a, b) {
            return a.prijs > b.prijs
        })

        return sortedRates
    },
    // finds rate name in usps rederij json
    rateName: state => rateCode => {
        let foundRate

        if (state.cruise.ratecode_usps && state.cruise.ratecode_usps.rates) {
            foundRate = state.cruise.ratecode_usps.rates.find(function(
                element
            ) {
                return element.rateCode === rateCode
            })
        }

        if (foundRate) {
            return foundRate.rateName
        }
        return rateCode
    },
    // finds rate code in usps rederij json
    rateCode: state => rateCode => {
        let foundRate

        if (state.cruise.ratecode_usps && state.cruise.ratecode_usps.rates) {
            foundRate = state.cruise.ratecode_usps.rates.find(function(
                element
            ) {
                return element.rateCode === rateCode
            })
        }

        if (foundRate) {
            return foundRate.rateCode
        }
        return rateCode
    },
    // returns cabin details from cabin code
    cabinDetail: state => cabinCode => {
        return state.cabins.collection.find(function(cabin) {
            if (typeof cabin === 'undefined') {
                return false
            }
            state.campagnes.find(function(departure) {
                if (departure.cruiseID === state.payload.cruiseID) {
                    if (departure.campagnes[0]) {
                        cabin.isCampagne = departure.campagnes[0].campagne_codes
                        cabin.campagneTitle =
                            departure.campagnes[0].omschrijving_kort
                    }
                }
            })
            return cabin.code.trim() === cabinCode.trim()
        })
    },
    // counts total pax for cruise segments
    totalPaxCount: state => {
        let count = 0
        for (let i = 0; i <= state.cabinCount - 1; i++) {
            let cabin = state.cabinSetup[i]
            count +=
                cabin.volwassenen + cabin.jeugd + cabin.kinderen + cabin.baby
        }

        return count
    },
    // get cleaned payload cabinpax from input index
    payloadCabinPaxObj: state => cabinIndex => {
        let obj = {}
        if (cabinIndex >= 0) {
            let cabin = state.payload.cabins[cabinIndex]
            if (cabin) {
                obj = {
                    volwassenen: parseInt(cabin.volwassenen),
                    jeugd: parseInt(cabin.jeugd),
                    kinderen: parseInt(cabin.kinderen),
                    baby: parseInt(cabin.baby),
                }
            }
        }

        return obj
    },

    // @todo this doesnt give back baby and jeugd
    // counts total pax for cruise segments
    totalPaxCountDetailed: state => {
        let countVolw = 0
        let countJeugd = 0
        let countKind = 0
        let countBaby = 0

        for (let i = 0; i <= state.cabinCount - 1; i++) {
            let cabin = state.cabinSetup[i]
            countVolw += cabin.volwassenen
            countJeugd += cabin.jeugd
            countKind += cabin.kinderen
            countBaby += cabin.baby
        }

        return {
            volwassenen: countVolw,
            jeugd: countJeugd,
            kinderen: countKind,
            baby: countBaby,
        }
    },

    highlightedDepartureDate: state => {
        if (state.highlightedRate) {
            const depIndex = state.highlightedRate.departureIndex
            if (
                depIndex > 0 ||
                (depIndex === 0 && state.departures.list.length > 0)
            ) {
                const depDate = state.departures.list[depIndex.toString()]
                return depDate.departureDate
            }
        }
    },

    showBoeken: (state, getters) => {
        //Business loqic to hide boeken
        const allowedCruiseBoeken = state.cruise.fibos_boeken === 'Y'
        const allowedCabinCount = state.cabinCount === 1
        const allowedPaxCount = getters.totalPaxCount < 5
        const depDate = getters.highlightedDepartureDate
        const allowedDepDate =
            moment
                .duration(moment(depDate, 'YYYY-MM-DD').diff(moment()))
                .asDays() > 14

        if (
            allowedCruiseBoeken &&
            allowedCabinCount &&
            allowedPaxCount &&
            allowedDepDate
        ) {
            return true
        }

        return false
    },

    fooienTotaal: (state, getters) => {
        let fooienTotaal = 0

        if (state.fooienType === 'inclusief') {
            let totalPaxCountDetailed = getters.totalPaxCountDetailed
            if (totalPaxCountDetailed.volwassenen) {
                fooienTotaal =
                    fooienTotaal +
                    state.cruise.tarief_fooien_volwassenen.globaal *
                        totalPaxCountDetailed.volwassenen
            }
            if (totalPaxCountDetailed.jeugd) {
                fooienTotaal =
                    fooienTotaal +
                    state.cruise.tarief_fooien_kinderen.globaal *
                        totalPaxCountDetailed.jeugd
            }
            if (totalPaxCountDetailed.kind) {
                fooienTotaal =
                    fooienTotaal +
                    state.cruise.tarief_fooien_kinderen.globaal *
                        totalPaxCountDetailed.kind
            }
            if (totalPaxCountDetailed.baby) {
                fooienTotaal =
                    fooienTotaal +
                    state.cruise.tarief_fooien_baby.globaal *
                        totalPaxCountDetailed.baby
            }
        }
        return fooienTotaal
    },

    verzorgingTotaal: (state, getters) => {
        let verzorgingTotaal = 0

        if (state.verzorgingType === 'all-inclusive' && state.selectedPakket) {
            let totalPaxCount = getters.totalPaxCount
            let pakket = state.selectedPakket

            if (totalPaxCount && pakket.pakket_prijs) {
                if (pakket.betalings_categorie === 2) {
                    //Prijs = totaalprijs
                    verzorgingTotaal =
                        state.selectedPakket.pakket_prijs * totalPaxCount
                } else if (pakket.betalings_categorie === 1) {
                    //Prijs = per nacht
                    verzorgingTotaal =
                        state.selectedPakket.pakket_prijs *
                        state.cruise.duur *
                        totalPaxCount
                } else {
                    //Prijs = per dag
                    verzorgingTotaal =
                        state.selectedPakket.pakket_prijs *
                        (parseInt(state.cruise.duur) + 1) *
                        totalPaxCount
                }
            }
        }
        return verzorgingTotaal
    },

    flightTotaal: (state, getters) => {
        let flightTotaal = 0
        // Model example
        // { "outbound": [ { "id": "1668545", "Identifier": "transavia", "Direction": "outbound", "departureAirport": "Amsterdam Airport Schiphol", "departureDate": "2020-01-13 07:00:00", "arrivalAirport": "Barcelona International Airport", "arrivalDate": "2020-01-13 09:15:00", "duration": "02:15:00", "flightNumber": "HV5131" } ], "inbound": [ { "id": "1695291", "Identifier": "transavia", "Direction": "inbound", "departureAirport": "Barcelona International Airport", "departureDate": "2020-01-20 17:40:00", "arrivalAirport": "Amsterdam Airport Schiphol", "arrivalDate": "2020-01-20 20:10:00", "duration": "02:30:00", "flightNumber": "HV5134" } ], "totalPrice": 115, "Identifier": "Database" }
        if (state.selectedFlight && state.selectedFlight.totalPrice > 0) {
            flightTotaal =
                parseInt(state.selectedFlight.totalPrice) *
                getters.totalPaxCount
        }

        return flightTotaal
    },

    // eslint-disable-next-line no-unused-vars
    filterFlightsCarrier: state => dataFlight => {
        let carrier = dataFlight.findCarrier
        let flights = dataFlight.flights
        if (carrier === '') {
            return flights
        }

        return flights.filter(function(fullFlight) {
            function filterFlight(flightSegment) {
                return flightSegment.airline.Code === carrier
            }

            let outboundFlight = fullFlight.outbound.filter(filterFlight)
            let inboundFlight = fullFlight.inbound.filter(filterFlight)

            return outboundFlight.length > 0 && inboundFlight.length > 0
        })
    },

    filterFlightsRate: state => dataFlight => {
        let rate = dataFlight.findRate
        let flights = dataFlight.flights
        if (rate === '') {
            return flights
        }

        return flights.filter(function(fullFlight) {


            return (fullFlight.displayFareType === rate)
        })
    },

    filterFlightsTime: () => flightData => {
        const inboundTime = flightData.findInboundDepartTime
        const outboundTime = flightData.findOutboundArriveTime
        let filtered = []

        flightData.flights.map(flight => {
            let outboundCount = 0 //Heenvlucht
            let inboundCount = 0 //Terugvlucht

            let filteredOutbound = []
            flight.outbound.map(outbound => {
                if (outbound.arrivalTime <= outboundTime) {
                    filteredOutbound.push(outbound)
                    outboundCount++
                }
            })

            let filteredInbound = []
            flight.inbound.map(inbound => {
                if (inbound.departureTime >= inboundTime) {
                    filteredInbound.push(inbound)
                    inboundCount++
                }
            })

            if (
                (inboundCount >= 1 || flightData.outboundOnly) &&
                (outboundCount >= 1 || flightData.inboundOnly)
            ) {
                flight.inbound = filteredInbound
                flight.outbound = filteredOutbound

                filtered.push(flight)
            }
        })

        return filtered
    },

    // eslint-disable-next-line no-unused-vars
    filterFlightsTransit: state => dataFlight => {
        let flights = dataFlight.flights

        let minWaiting = parseInt(dataFlight.minWaiting)
        let maxWaiting = parseInt(dataFlight.maxWaiting)

        function totalWaitingSeconds(segment) {
            let seconds = 0

            if (!segment.waitingTime || segment.waitingTime === '0') {
                return seconds
            }
            let a = segment.waitingTime.split(':') // split it at the colons
            seconds += +a[0] * 60 * 60 + +a[1] * 60

            return seconds
        }

        return flights.filter(function(fullFlight) {
            function filterFlight(flight) {
                if (
                    flight.segments[0] == null ||
                    flight.segments[0] === 'undefined'
                ) {
                    return true
                }

                let segmentsTotalWaitingSeconds = totalWaitingSeconds(
                    flight.segments[0]
                )
                if (segmentsTotalWaitingSeconds === 0) {
                    return true
                }

                if (minWaiting <= 0) {
                    return true
                }

                let minWaitingSeconds = minWaiting * 60 * 60
                let maxWaitingSeconds = maxWaiting * 60 * 60

                return (
                    segmentsTotalWaitingSeconds >= minWaitingSeconds &&
                    segmentsTotalWaitingSeconds <= maxWaitingSeconds
                )
            }

            let outboundFlight = fullFlight.outbound.filter(filterFlight)
            let inboundFlight = fullFlight.inbound.filter(filterFlight)

            if (outboundFlight.length > 0 && inboundFlight.length > 0) {
                return true
            }
            return (
                (dataFlight.outboundOnly || outboundFlight.length > 0) &&
                (dataFlight.inboundOnly || inboundFlight.length > 0)
            )
        })
    },

    payloadCabinPaxCount: state => cabinIndex => {
        let count = 0

        if (cabinIndex >= 0) {
            let cabin = state.payload.cabins[cabinIndex]
            if (cabin) {
                count =
                    parseInt(cabin.volwassenen) +
                    parseInt(cabin.jeugd) +
                    parseInt(cabin.kinderen) +
                    parseInt(cabin.baby)
            }
        }
        return count
    },

    totalPrice: (state, getters) => {
        let totalPrice = 0

        for (let i = 0; i <= state.cabinCount - 1; i++) {
            let cabin = state.cabinSetup[i]
            let rate = getters.flattenedRates[cabin.rateSelectIndex]

            if (!rate) {
                continue
            }
            let vCount = 0
            for (let volw = 1; volw <= cabin.volwassenen; volw++) {
                vCount++
                totalPrice += rate.prijs
            }
            if (vCount === 1) {
                totalPrice += rate.prijs
            }
            for (let jeugd = 1; jeugd <= cabin.jeugd; jeugd++) {
                totalPrice += rate.prijs
            }
            for (let kinderen = 1; kinderen <= cabin.kinderen; kinderen++) {
                totalPrice += rate.prijs
            }
            for (let baby = 1; baby <= cabin.baby; baby++) {
                totalPrice += rate.prijs
            }
        }

        if (totalPrice > 0) {
            totalPrice += state.calamiteitenFonds
            totalPrice += state.sgrFonds
            totalPrice += getters.fooienTotaal
            totalPrice += getters.verzorgingTotaal
            totalPrice += getters.flightTotaal
        }
        return Math.floor(totalPrice)
    },
}

const actions = {
    loadCruise({ commit, getters }, input) {
        commit('mutateCruise', { input, getters })
    },

    deleteRoutes({ commit, getters }, input) {
        commit('deleteRoutes', input)
    },

    loadFlightsForDossier({ commit }, input) {
        commit('mutateFlightsForDossier', input)
    },
    loadAirportsForDossier({ commit }, input) {
        commit('mutateAirportsForDossier', input)
    },

    saveFlightsForDossier({ commit }, input) {
        commit('mutateAddFlightToDossier', input)
    },

    loadCabinsForDossier({ commit }, input) {
        commit('mutateCabinsForDossier', input)
    },

    loadCabinNumberForDossier({ commit }, input) {
        commit('mutateCabinNumbers', input)
    },

    loadDeckMap({ commit }, input) {
        commit('mutateDeckMap', input)
    },

    toggleFooi({ commit }, input) {
        commit('mutateToggleFooi', input)
    },

    saveCabinForDossier({ commit }, input) {
        commit('mutateAddCabinToDossier', input)
    },
    // eslint-disable-next-line no-unused-vars
    highlightDeparture({ commit, state, getters }, input) {
        // Set cruiseID and departureindex,
        // triggers updates the date values in page
        // (Does nothing with prices or rate)
        commit('mutateDeparture', input)

        // Retrieve campagne info for new cruise,
        // triggers updates to render a campagne block when needed
        // (Does nothing with prices or rate)
        commit('mutateCampagnes', input)

        // Get flights for cruise
        commit('mutateFlights', input)
        // Updates the url and prices/rate, triggers the new price and rate
        commit('mutateDepartureRate', { input, getters })
    },

    // saves offer to db and returns new dossier ID
    saveOfferRequest({ commit, state, getters }, input) {
        let payload = {}
        let CabinRates = []
        payload.action = 'createOfferSimple'
        payload.paxInfo = {
            collection: [
                {
                    voornaam: input.naam,
                    emailadres: input.email,
                    telefoonnummer: input.telefoonnummer,
                },
            ],
        }

        for (let i = 0; i <= state.cabinCount - 1; i++) {
            let cabin = state.cabinSetup[i]
            let rate = getters.flattenedRates[cabin.rateSelectIndex]

            let cabinSetup = {
                volwassenen: cabin.volwassenen,
                jeugd: cabin.jeugd,
                kinderen: cabin.kinderen,
                baby: cabin.baby,
                rate: rate,
            }

            let b
            for (let a = 0; a <= cabin.kindCount - 1; a++) {
                b = a + 1
                cabinSetup['kind_leeftijd_' + b] = cabin.kindLeeftijden[a]
                cabinSetup['kind_geboortedatum_' + b] =
                    cabin.kindGeboortedatum[a]
            }
            CabinRates.push(cabinSetup)
        }

        payload.opmerking = input.opmerking

        payload.cruiseID = state.highlightedRate.cruiseID

        payload.vluchten = input.vluchten
        payload.transfers = input.transfers
        payload.cabins = CabinRates

        payload.verzorgingType = state.verzorgingType
        payload.verzorgingPrijs = getters.verzorgingTotaal

        payload.fooienType = state.fooienType
        payload.fooienPrijs = getters.fooienTotaal

        payload.totalPrice = getters.totalPrice

        payload.totalPax = getters.totalPax

        commit('mutateSaveOfferRequest', payload)
    },

    saveBelMeRequest({ commit }, input) {
        commit('mutateBelMeRequest', input)
    },

    saveLog({ commit }, input) {
        commit('logError', input)
    },
}

export default new Vuex.Store({
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
})
